import React from 'react';
import bacteriaUI from '../assets/bacteria-ui.jpg';
import cartridgeImg from '../assets/cartridge.jpg';
import reagentImg from '../assets/reagent.jpg';

export default function HowItWorks() {
  return (
    <section id="specs" className="scroll-mt-28 bg-white py-16 sm:py-20 text-gray-800">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-teal-700 mb-10">
          How It Works: Simple 5-Step Process
        </h2>

        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Left: Steps */}
          <div className="flex-1 space-y-5">
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center font-semibold shadow-md">1</div>
              <div>
                <h3 className="text-base font-semibold text-gray-800">Insert Cartridge</h3>
                <p className="text-sm text-gray-600">
                  Place the testing cartridge into the top opening of the Bactest Device.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center font-semibold shadow-md">2</div>
              <div>
                <h3 className="text-base font-semibold text-gray-800">Add Water Sample</h3>
                <p className="text-sm text-gray-600">
                  Add water sample to be tested into the cartridge.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center font-semibold shadow-md">3</div>
              <div>
                <h3 className="text-base font-semibold text-gray-800">Add Reagent</h3>
                <p className="text-sm text-gray-600">
                  Add specialized reagent to the cartridge to begin testing process.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center font-semibold shadow-md">4</div>
              <div>
                <h3 className="text-base font-semibold text-gray-800">Automated Processing</h3>
                <p className="text-sm text-gray-600">
                  The device processes and detects any bacteria within 3–6 hours.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center font-semibold shadow-md">5</div>
              <div>
                <h3 className="text-base font-semibold text-gray-800">Instant Results</h3>
                <p className="text-sm text-gray-600">
                  Results display online or on our dedicated mobile application.
                </p>
              </div>
            </div>
          </div>

          {/* Right: UI + Images */}
          <div className="flex-1 flex flex-col items-center gap-6 bg-gray-50 rounded-2xl p-8 border border-gray-100">
            <img src={bacteriaUI} alt="Device UI" className="rounded-xl shadow-md max-w-xs" />
            <p className="text-sm font-medium text-gray-600">Application</p>
            <div className="flex gap-8 items-center">
              <div className="flex flex-col items-center">
                <img src={cartridgeImg} alt="Cartridge" className="h-20 object-contain" />
                <p className="mt-2 text-sm font-medium text-gray-600">Cartridge</p>
              </div>
              <div className="flex flex-col items-center">
                <img src={reagentImg} alt="Reagent" className="h-20 object-contain" />
                <p className="mt-2 text-sm font-medium text-gray-600">Reagent</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom line */}
        <p className="mt-12 text-center text-teal-800 bg-teal-100/60 max-w-3xl mx-auto text-sm leading-relaxed px-6 py-4 rounded-xl">
          The entire process requires minimal training and can be performed by anyone,
          democratizing water testing across all communities.
        </p>
      </div>
    </section>
  );
}
